import { cn } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import { useDeps } from '@Contexts/DI';
import Video from '@Components/Video';
import Link from '@UI/Link';
import assets from './assets';
import styles from './CollectYourRibble.module.css';

import type { FC } from 'react';

interface CollectYourRibbleProps {
  className?: string;
  modelId?: number;
  fabricId?: number;
  configurationId?: number;
}

const CollectYourRibble: FC<CollectYourRibbleProps> = (props) => {
  const { className, modelId, fabricId, configurationId, ...restProps } = props;
  const { t } = useTranslation();
  const { analytics } = useDeps();

  const handleClickAction = () => {
    analytics.dispatchEvent('ribbl.configuratorRibble', {
      category: 'Configurator_Ribble',
      label: 'CardInfo',
      action: 'click',
    });
    ModalWindows.open('ModuleConstructor', {
      modelId,
      fabricId,
      configurationId,
      code: 'ribble',
      source: 'ribble',
    });
  };

  return (
    <div {...restProps} className={cn(styles.wrapper, className)} data-testid='collect-ribble'>
      <Video className={styles.video} autoPlay loop src={assets.video} poster={assets.image} />
      <div className={styles.text}>
        <div className={styles.title}>{t('ribble.banner.title')}</div>
        <div className={styles.description}>{t('ribble.banner.description')}</div>
        <Link
          className={styles.link}
          onClick={handleClickAction}
          data-testid='ribble-constructor-link'
        >
          {t('ribble.banner.link')}
        </Link>
      </div>
    </div>
  );
};

export default CollectYourRibble;
